import * as React from "react";
import PropTypes from "prop-types";
import { Tabs, Tab, Box, Container } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import Statistics from "./Pages/Statistics";
import Users from "./Pages/Users";
import Students from "./Pages/Students";
import Teachers from "./Pages/Teachers";
import Groups from "./Pages/Groups";
import Offices from "./Pages/Offices";
import Schedules from "./Pages/Schedules";
import News from "./Pages/News";
import Subjects from "./Pages/Subjects";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      sx={{ width: "100%" }}
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function AdminLayout() {
  const [value, setValue] = React.useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Container
      sx={{
        display: "flex",
        maxWidth: "lg",
        flexDirection: isMobile ? "column" : "row",
        minHeight: 224,
        mt: 12,
        justifyContent: "space-between",
      }}>
      <Tabs
        orientation={isMobile ? "horizontal" : "vertical"}
        variant="scrollable"
        value={value}
        onChange={handleChange}
        scrollButtons="auto"
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: "divider", overflow: "visible" }}>
        <Tab label="Статистика" {...a11yProps(0)} />
        <Tab label="Пользователи" {...a11yProps(1)} />
        <Tab label="Студенты" {...a11yProps(2)} />
        <Tab label="Преподаватели" {...a11yProps(3)} />
        <Tab label="Группы" {...a11yProps(4)} />
        <Tab label="Кабинеты" {...a11yProps(5)} />
        <Tab label="Расписание" {...a11yProps(6)} />
        <Tab label="Новости" {...a11yProps(7)} />
        <Tab label="Уроки" {...a11yProps(8)} />
      </Tabs>
      <TabPanel value={value} index={0}>
        <Statistics />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Users />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Students />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Teachers />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <Groups />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <Offices />
      </TabPanel>

      <TabPanel value={value} index={6}>
        <Schedules />
      </TabPanel>
      <TabPanel value={value} index={7}>
        <News />
      </TabPanel>
      <TabPanel value={value} index={8}>
        <Subjects />
      </TabPanel>
    </Container>
  );
}
